import { useQueryClient } from '@tanstack/react-query';
import { usePutSettingsGeneral } from '../api/generated/arrayscapeGamingDashboardAPI';

export { type GeneralSettings } from '../api/generated/model';

/**
 * React Query mutation hook for updating general settings.
 * Automatically invalidates and refetches the settings after a successful update.
 *
 * Usage:
 * const mutation = useUpdateGeneralSettings();
 * mutation.mutate(newSettings);
 */
export const useUpdateGeneralSettings = () => {
  const queryClient = useQueryClient();

  return usePutSettingsGeneral({
    mutation: {
      onSuccess: () => {
        // Explicitly refetch general settings after successful update
        queryClient.invalidateQueries({ queryKey: ['settings', 'general'] });
      },
    },
  });
};
